import React from "react";
import { Mail, Globe, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      id="contact-section"
      className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Brand section */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img
                src="/assets/logo-white.png"
                alt="Encryptofy Mail Logo"
                className="h-12 w-auto"
              />
            </div>

            <p className="text-slate-300 text-lg leading-relaxed max-w-md">
              Delivering enterprise-grade email security and privacy protection
              for professionals and organizations worldwide.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-300">
                <Mail className="h-5 w-5 text-blue-400" />
                <a
                  href="mailto:info@encryptofymail.com"
                  className="hover:text-teal-400 transition-colors duration-200"
                >
                  info@encryptofymail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-slate-300">
                <Phone className="h-5 w-5 text-blue-400" />
                <a
                  href="tel:+18773045804"
                  className="hover:text-teal-400 transition-colors duration-200"
                >
                  +1 (877) 304-5804
                </a>
              </li>
              <li className="flex items-center gap-2 text-slate-300">
                <Globe className="h-5 w-5 text-blue-400" />
                <a
                  href="https://www.encryptofymail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-teal-400 transition-colors duration-200"
                >
                  www.encryptofymail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Encryptofy Mail. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link
                to="/privacy-policy"
                className="text-slate-400 hover:text-teal-400 transition-colors duration-200 text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-slate-400 hover:text-teal-400 transition-colors duration-200 text-sm"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
